(function () {
    'use strict';

    angular
        .module('app.memberAdmin')
        .component('sc3ModifyHandicap', {
            templateUrl: 'app/member-admin/modify-handicap/modify-handicap.component.html',
            controller: ModifyHandicapComponent,
            bindings: {
                data: '<'
            }
        });

    ModifyHandicapComponent.$inject = ['$state', '$scope', '$timeout', 'Member', 'alert', 'handicapSuffix', 'memberAdminResources'];
    function ModifyHandicapComponent($state, $scope, $timeout, Member, alert, handicapSuffix, resources) {
        var ctrl = this,
            today = new Date(new Date().setHours(0, 0, 0, 0));

        // Properties
        Object.defineProperty(ctrl, 'isModifyLow', { get: getIsModifyLow });
        Object.defineProperty(ctrl, 'isWithdraw', { get: getIsWithdraw });        
        ctrl.suffixList = Object.values(handicapSuffix.$metadata);
        ctrl.startDateOptions = { minDate: today };
        ctrl.endDateOptions = { minDate: today };

        // Methods
        ctrl.$onInit = init;
        ctrl.submit = submit;
        ctrl.suffixChanged = suffixChanged;
        ctrl.validateHcpRequiredIfNotWD = validateHcpRequiredIfNotWD;
        ctrl.validateHcpMustBeNullIfWD = validateHcpMustBeNullIfWD;
        ctrl.validateEndDateVsStartDate = validateEndDateVsStartDate;

        /////////////////////////////////////////////

        function init() {
            ctrl.handicap = ctrl.data.handicap;
            ctrl.clubs = ctrl.data.clubs;
        }

        function submit() {
            var handicap = ctrl.handicap;
            if (ctrl.form.$valid) 
                Member.saveModifiedHandicap({ id: handicap.individualId }, handicap, success, error, true);

            function success() {
                $scope.$emit('$userChanged');
                $timeout(alert.success.bind(alert, resources.modifyHandicapSucceeded));
            }
            function error() {
                alert.error(resources.modifyHandicapFailed);
            }
        }
        function suffixChanged() {
            if (ctrl.handicap.suffix === handicapSuffix.Withdraw) {
                ctrl.handicap.value = null;
            }                
            if (ctrl.handicap.suffix === handicapSuffix.ModifyLow) {
                ctrl.startDate.value = today;
            }                
        }
        function getIsModifyLow() {
            return ctrl.handicap.suffix === handicapSuffix.ModifyLow;
        }
        function validateHcpRequiredIfNotWD(handicap) {
            return ctrl.isWithdraw || handicap != null;
        }
        function validateHcpMustBeNullIfWD(handicap) {
            return !ctrl.isWithdraw || handicap == null;
        }
        function validateEndDateVsStartDate(endDate) {
            var startDate = ctrl.handicap.startDate;
            return !endDate || !startDate || endDate >= startDate;
        }
        function getIsWithdraw() {
            return ctrl.handicap.suffix === handicapSuffix.Withdraw;
        }
     
    }
})();